export const oogledenOptions = [
    { key: 'blepharitis', text: 'Blepharitis' },
    { key: 'chalazion', text: 'Chalazion' },
    { key: 'dermatochalasis', text: 'Dermatochalasis' },
    { key: 'ectropion', text: 'Ectropion' },
    { key: 'entropion', text: 'Entropion' },
    { key: 'hordeolum', text: 'Hordeolum' },
    { key: 'MGD', text: 'MGD' },
    { key: 'ptosis', text: 'Ptosis' },
    { key: 'zwelling', text: 'Zwelling' },
    { key: 'andersText' },
];

export const conjunctivaOptions = [
    { key: 'chemosis', text: 'Chemosis' },
    { key: 'roodheid', text: 'Roodheid' },
    { key: 'follikels', text: 'Follikels' },
    { key: 'hyperemie', text: 'Hyperemie' },
    { key: 'papillen', text: 'Papillen' },
    { key: 'subconjunctivaleBloeding', text: 'Subconjunctivale bloeding' },
    { key: 'andersText' },
];

export const corneaOptions = [
    { key: 'corneadystrofie', text: 'Corneadystrofie' },
    { key: 'erosie', text: 'Erosie' },
    { key: 'fuchs', text: 'Fuchs' },
    { key: 'guttata', text: 'Guttata' },
    { key: 'infiltraat', text: 'Infiltraat' },
    { key: 'keratoconus', text: 'Keratoconus' },
    { key: 'krukenbergSpindle', text: 'Krukenberg spindle' },
    { key: 'mapDotFingerprintDystrofie', text: 'Map-dot-fingerprint dystrofie' },
    { key: 'neovascularisatie', text: 'Neovascularisatie' },
    { key: 'oedeem', text: 'Oedeem' },
    { key: 'pterygium', text: 'Pterygium' },
    { key: 'punctata', text: 'Punctata' },
    { key: 'ulcus', text: 'Ulcus' },
    { key: 'andersText' },
];

export const vokWriteOptions = [
    { key: 'cellen', text: 'Cellen' },
    { key: 'tyndall', text: 'Tyndall' },
    { key: 'andersText' },
];

export const vokReadOptions = [...vokWriteOptions, { key: 'kamerhoekVanHerick', text: 'Kamerhoek van Herick' }];

export const irisOptions = [
    { key: 'diafanie', text: 'Diafanie' },
    { key: 'naevus', text: 'Naevus' },
    { key: 'rubeosis', text: 'Rubeosis' },
    { key: 'andersText' },
];

export const lensOptions = [
    { key: 'lenssclerose', text: 'Lenssclerose' },
    { key: 'cataract_beginnend', text: 'Cataract beginnend' },
    { key: 'cataract_storend', text: 'Cataract storend' },
    { key: 'pseudofaak', text: 'Pseudofaak' },
    { key: 'nastaar', text: 'Nastaar' },
    { key: 'pseudoexfoliate', text: 'Pseudoexfoliatie' },
    { key: 'andersText' },
];

export const glasvochtOptions = [
    { key: 'exfoliatie', text: 'Exfoliatie' },
    { key: 'glasvochtbloeding', text: 'Glasvochtbloeding' },
    { key: 'glasvochtloslating', text: 'Glasvochtloslating' },
    { key: 'mouchesVolantes', text: 'Mouches volantes' },
    { key: 'tobaccoDust', text: 'Tobacco dust' },
    { key: 'andersText' },
];

export const perifereRetinaOptions = [
    { key: 'ablatio', text: 'Ablatio' },
    { key: 'arterieleStamocclusie', text: 'Arteriele stamocclusie (CRAO)' },
    { key: 'arterieleTakocclusie', text: 'Arteriele takocclusie (BRAO)' },
    { key: 'atherosclerosis', text: 'Atherosclerosis' },
    { key: 'beading', text: 'Beading' },
    { key: 'bloeding', text: 'Bloeding' },
    { key: 'cottonWoolSpots', text: 'Cotton wool spots' },
    { key: 'drusen', text: 'Drusen' },
    { key: 'exsudaten', text: 'Exsudaten' },
    { key: 'hypertensieveRetinopathie', text: 'Hypertensieve retinopathie' },
    { key: 'IRMA', text: 'IRMA' },
    { key: 'latticeDegeneratie', text: 'Lattice degeneratie' },
    { key: 'microaneurysma', text: 'Microaneurysma' },
    { key: 'naevus', text: 'Naevus' },
    { key: 'neovascularisatie', text: 'Neovascularisatie' },
    { key: 'netvliesdefect', text: 'Netvliesdefect' },
    { key: 'netvliesscheur', text: 'Netvliesscheur' },
    { key: 'PEA', text: 'Pigment epitheel alteraties (PEA)' },
    { key: 'venaTakocclusie', text: 'Venatak occlusie (BRVO) ' },
    { key: 'venaStamocclusie', text: 'Vena stamocclusie (CRVO)' },
    { key: 'andersText' },
];

export const papilOptions = [
    { key: 'excavatie', text: 'Excavatie' },
    { key: 'glaucoomsuspect', text: 'Glaucoomsuspect' },
    { key: 'neovascularisatie', text: 'Neovascularisatie' },
    { key: 'oedeem', text: 'Oedeem' },
    { key: 'peripapillaireAtrofie', text: 'Peripapillaire atrofie' },
    { key: 'tilted', text: 'Tilted' },
    { key: 'vlamvormigeBloeding', text: 'Vlamvormige bloeding' },
    { key: 'andersText' },
];

export const maculaOptions = [
    { key: 'bloeding', text: 'Bloeding' },
    { key: 'drusen', text: 'Drusen' },
    { key: 'macula_degeneratie', text: 'Maculadegeneratie' },
    { key: 'maculopathie', text: 'Maculopathie' },
    { key: 'oedeem', text: 'Oedeem' },
    { key: 'pigmentepitheel_alteraties', text: 'Pigmentepitheel alteraties' },
    { key: 'pucker', text: 'Pucker' },
    { key: 'andersText' },
];

export type AfwijkingOption =
    | 'oogleden'
    | 'conjunctiva'
    | 'cornea'
    | 'vok'
    | 'iris'
    | 'lens'
    | 'glasvocht'
    | 'perifere_retina'
    | 'papil'
    | 'macula';

export const AfwijkingOptionLabel = {
    conjunctiva: 'Conjunctiva',
    cornea: 'Cornea',
    glasvocht: 'Glasvocht',
    iris: 'Iris',
    lens: 'Lens',
    macula: 'Macula',
    oogleden: 'Oogleden',
    papil: 'Papil',
    perifere_retina: 'Perifere retina',
    vok: 'Vok',
};

export const afwijkingInVoOptions: AfwijkingOption[] = ['oogleden', 'conjunctiva', 'cornea', 'vok', 'iris', 'lens'];

export const afwijkingInAoOptions: AfwijkingOption[] = ['glasvocht', 'perifere_retina', 'papil', 'macula'];

export const afwijkingReadOptions: { [K in AfwijkingOption]: { key: string; text?: string }[] } = {
    conjunctiva: conjunctivaOptions,
    cornea: corneaOptions,
    glasvocht: glasvochtOptions,
    iris: irisOptions,
    lens: lensOptions,
    macula: maculaOptions,
    oogleden: oogledenOptions,
    papil: papilOptions,
    perifere_retina: perifereRetinaOptions,
    vok: vokReadOptions,
};

export const afwijkingWriteOptions: { [K in AfwijkingOption]: { key: string; text?: string }[] } = {
    ...afwijkingReadOptions,
    vok: vokWriteOptions,
};

export function isAfwijkingOption(name: string): name is AfwijkingOption {
    return Object.keys(afwijkingWriteOptions).includes(name);
}
